export const TEXT_RESOURCE = 'text';
